import { message } from "antd";
import { checkAuthorization } from "../../helpers";
import { domainUrl } from "../../constants";

const transferMoney = (object) => {

    const {userToken} = checkAuthorization()
    var myHeaders = new Headers()
    myHeaders.append('Authorization', userToken)
    myHeaders.append("Content-Type", "application/json")
    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(object),
        redirect: 'follow'
    };
    let url = object?.isEdit ? "/updateBankTransfer" :"/storeBankTransfer"
    return (
        fetch(domainUrl + url, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result?.success) {
                message.success(result?.message)
                return 1
            } 
            else 
                throw result?.message
        })
        .catch(error => {
            message.error(error || 'Something went wrong');
            return 0
        })
    )
}

const bankTransfer = {
    transferMoney
}

export {bankTransfer}